import script from "./image-upload.vue?vue&type=script&setup=true&lang=js"
export * from "./image-upload.vue?vue&type=script&setup=true&lang=js"

import "./image-upload.vue?vue&type=style&index=0&id=62d546ad&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/web-project4knfj/booltool-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d546ad"]])

export default __exports__